import { TextField } from "@material-ui/core"
import { SelectComponent } from "components/SelectMenu/SelectComponent"
import React from "react"
const getComponent = (label, value, inputType, isRequired) => {

  return (
    <>
      {
        inputType === 'text'
          ?
          <TextField label={label} name={value} value={value} variant='outlined'
            fullWidth size="small" required={isRequired} />

          :
          <SelectComponent label={label} name={value} value={value} options={[]} small required={isRequired} />
      }
    </>
  )
}

export const constructComponent = (input) => {
  const splitInput = input.split(' ').filter(input => input.length > 0)
  const newComponent = {
    label: splitInput[0],
    value: splitInput[1],
    type: splitInput[2] || 'text',
    cols: splitInput[3],
    isRequired: splitInput[4] !== undefined ? JSON.parse(splitInput[4]) : false,
    component: getComponent(splitInput[0], splitInput[1], splitInput[2], splitInput[3], splitInput[4])
  }
  return newComponent
}